module.exports = __webpack_public_path__ + "img/max-file-content-image-add.62ba8599.svg";